import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { Button, Icon } from 'rhinostyle';
import { isWebRTCSupported, isMobile } from '../helpers/BrowserHelpers';
import { setRhinocallPreconfig, checkAudioPermission, getLastMemberNumber, handleCompleteCall, handleHangup, resetCall } from '../reducers/rhinocallReducer';
import { getContactCallStatus, getMemberCall } from '../selectors/rhinocallSelector';
import { getActiveMemberVideo } from '../selectors/rhinovideoSelectors';
import { toggleModal } from '../reducers/threadReducer';
import { fetchChannels } from '../reducers/channelReducer';
import { MODAL_OPTIONS } from '../constants/ThreadConstants';

const RhinocallStartButton = (props) => {
  const dispatch = useDispatch();
  const {
    contactCallStatus,
    memberHasActiveVideo,
    isHangingUp,
    getActiveMemberCall,
  } = props;

  const handleToggleRhinocallModal = async () => {
    dispatch(resetCall());
    if (isMobile()) {
      return dispatch(setRhinocallPreconfig());
    } if (!isWebRTCSupported()) {
      return toggleModal(MODAL_OPTIONS.browserNotSupported);
    } return dispatch(checkAudioPermission())
      .catch(() => toggleModal(MODAL_OPTIONS.audioAccess));
  };

  const handleToggleHangup = () => {
    dispatch(handleCompleteCall(getActiveMemberCall));
    dispatch(handleHangup());
  };

  useEffect(() => {
    dispatch(fetchChannels());
    if (isMobile()) {
      dispatch(getLastMemberNumber());
    }
  }, []);

  const isCallNowVisible = !!contactCallStatus || memberHasActiveVideo || isHangingUp;

  const renderButton = () => {
    if (isCallNowVisible) {
      return (
        <Button
          className="convo__start-button"
          onClick={handleToggleHangup}
          size="small"
          data-cypress="callStartButton"
          type="danger"
        >
          <Icon size="large" icon="phone" />
          <span className="u-hidden-xsmall rhinocall__action-bar__label">&nbsp;End Call</span>
        </Button>
      );
    } else {
      return (
        <Button
          disabled={!!contactCallStatus || memberHasActiveVideo || isHangingUp}
          className={`convo__start-button ${contactCallStatus ? 'u-muted-outline' : ''}`}
          onClick={handleToggleRhinocallModal}
          size="small"
          type="outline"
          data-cypress="callStartButton"
        >
          <Icon size="large" icon="phone" />
          <span className="u-hidden-xsmall">&nbsp;Call Now</span>
        </Button>
      );
    }
  };

  return (
    renderButton()
  );
};

RhinocallStartButton.propTypes = {
  contactCallStatus: PropTypes.string,
  memberHasActiveVideo: PropTypes.bool,
  isHangingUp: PropTypes.bool,
  isRhinocallModalVisible: PropTypes.bool,
  getActiveMemberCall: PropTypes.object,
};

const mapStateToProps = (state) => ({
  contactCallStatus: getContactCallStatus(state),
  memberHasActiveVideo: getActiveMemberVideo(state)?.length > 0,
  isHangingUp: state.rhinocall.isHangingUp,
  isRhinocallModalVisible: state.rhinocall.isRhinocallModalVisible,
  getActiveMemberCall: getMemberCall(state),
});

export default connect(mapStateToProps)(RhinocallStartButton);
